import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "cards-wr" }
const _hoisted_3 = {
  key: 0,
  class: "card"
}
const _hoisted_4 = { class: "block" }
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = { class: "row-value" }
const _hoisted_7 = {
  key: 1,
  class: "row"
}
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = {
  key: 2,
  class: "row"
}
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = {
  key: 3,
  class: "row"
}
const _hoisted_12 = { class: "row-value" }
const _hoisted_13 = {
  key: 4,
  class: "row"
}
const _hoisted_14 = { class: "row-value" }
const _hoisted_15 = {
  key: 5,
  class: "row"
}
const _hoisted_16 = { class: "row-value" }
const _hoisted_17 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "title-main" }, "General Settings", -1)),
    _createElementVNode("div", _hoisted_2, [
      ($setup.user)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "block-title" }, "Account Details", -1)),
            _createElementVNode("div", _hoisted_4, [
              ($setup.isLandownerRole)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-title" }, "Company Name", -1)),
                    _createElementVNode("div", _hoisted_6, _toDisplayString($setup.user.detailsId.companyName), 1)
                  ]))
                : _createCommentVNode("", true),
              ($setup.isLandownerRole)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-title" }, "Address", -1)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString($setup.user.detailsId.companyAddress), 1)
                  ]))
                : _createCommentVNode("", true),
              ($setup.isLandownerRole)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-title" }, "ABN / ACN", -1)),
                    _createElementVNode("div", _hoisted_10, _toDisplayString($setup.user.detailsId.abnAcn), 1)
                  ]))
                : _createCommentVNode("", true),
              ($setup.isLandownerRole || $setup.isSalesPersonRole)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-title" }, "Full Name", -1)),
                    _createElementVNode("div", _hoisted_12, _toDisplayString($setup.getFirstLastName($setup.user)), 1)
                  ]))
                : _createCommentVNode("", true),
              ($setup.isLandownerRole || $setup.isSalesPersonRole)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-title" }, "Phone", -1)),
                    _createElementVNode("div", _hoisted_14, _toDisplayString($setup.user.phone), 1)
                  ]))
                : _createCommentVNode("", true),
              ($setup.isLandownerRole || $setup.isSalesPersonRole)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-title" }, "Email", -1)),
                    _createElementVNode("div", _hoisted_16, _toDisplayString($setup.user.email), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_router_link, {
                class: "button default primary v2",
                to: { name: 'ProfileUpdateV2' }
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Edit Info", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "button default password",
                to: { name: 'ProfileChangePasswordV2' }
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("Change Password", -1)
                ]))]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}